import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import { fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate } from '../../actions/purchaseTemplates_actions';
import { resetCurrentPurchaseQuote } from '../../actions/purchaseQuotes_actions';

import PurchaseQuoteModal from '../../components/Purchase/purchaseQuoteModal';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  }
  return errors
}


let purchaseQuoteModal = reduxForm({
    form: 'purchaseQuoteModal',
})(PurchaseQuoteModal); 

const selector = formValueSelector('purchaseQuoteModal')

function mapStateToProps(state) {
    const purchaseTemplateValue = selector(state, 'PurchaseTemplate_id');
    return {
        purchaseTemplateValue: purchaseTemplateValue,

        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        purchaseTemplates: state.purchaseTemplates.all,
        isLoading: state.purchaseTemplates.isLoading,
        error: state.purchaseTemplates.error
    }
}

export default connect(mapStateToProps, { fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate, resetCurrentPurchaseQuote })(purchaseQuoteModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseQuoteModal.jsx